import { IBusiness } from '@/coreDomainsModule/entities/businessBase';

/**
 *
 * @param business
 */
const calculateRecommendOrderQuantity = function (business: IBusiness): number {
  const recommendStdInventoryName = '標準在庫指数';
  const stdInventoryIndexMin = business?.stdInventoryIndices?.[recommendStdInventoryName]?.min || 0;
  const stdInventoryIndexMax = business?.stdInventoryIndices?.[recommendStdInventoryName]?.max || stdInventoryIndexMin;
  const stdIndex = stdInventoryIndexMin || 1;
  // 倍率が1以上になるようにする (本当は計算ロジックにこの処理入れたくなかったんだけど0が入る考慮がめんどくさいので)
  const maxInventoryIndex = !stdInventoryIndexMax || stdInventoryIndexMax < stdIndex ? stdIndex : stdInventoryIndexMax;
  // const recommendDiff = business.recommend?.[0]?.diff || 0;
  const recommendDiff = 0;
  const maxInventoryIndexAmount = calculateOrderDiffAmount(recommendDiff, maxInventoryIndex, stdIndex);
  return Math.ceil(maxInventoryIndexAmount);
};

/**
 *
 * @param recommendDiff
 * @param maxInventoryIndex
 * @param stdIndex
 */
const calculateOrderDiffAmount = function (recommendDiff: number, maxInventoryIndex: number, stdIndex: number): number {
  return recommendDiff * (maxInventoryIndex / stdIndex);
};

export default calculateRecommendOrderQuantity;
export { calculateOrderDiffAmount };
